import { error } from "../messages";
import { saveBlob } from "../saveFile";
import { handleError } from "../errorLogger";
import { checkHttpStatus, post } from "../httpFunctions";

/**
 * vytvoří pdf se seznamem entit
 * @param {any[]} entities seznam entit
 * @param {any} intl intl
 * @param {boolean} addressExport jestli se jedna o adresy
 */
export function exportEntities(entities, intl, addressExport) {
  post(
    `${addressExport ? "address" : "invoice"}/print-list`,
    { ids: entities.map((a) => a.key) },
    true,
    undefined,
    true
  )
    .then((r) => {
      if (checkHttpStatus(r)) {
        saveBlob(
          r.data,
          addressExport ? "customers.pdf" : "invoices.pdf"
        );
      } else {
        error(
          (r.data && r.data.message) ||
            intl.formatMessage({
              id: "export.error",
              defaultMessage: "Při exportu dat nastala chyba.",
            })
        );
      }
    })
    .catch((err) => {
      handleError(err);
      error(
        intl.formatMessage({
          id: "export.error",
          defaultMessage: "Při exportu dat nastala chyba.",
        })
      );
    });
}
